import { render, staticRenderFns } from "./demoOrderRecord.vue?vue&type=template&id=caae74cc"
import script from "./demoOrderRecord.vue?vue&type=script&lang=js"
export * from "./demoOrderRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports